import axios from 'axios';
import i18n from '@/i18n';

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;

axios.interceptors.request.use(
  (config) => {
    const existing = config.headers?.['Accept-Language'] || config.headers?.['accept-language'];
    if (!existing) {
      const language = i18n.global.locale.value;
      if (language) {
        config.headers['Accept-Language'] = language;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axios;